<template>
<div>
  <near-by-list :is-near-by-sidebar-active.sync="isNearBySidebarActive" :placeData="placeData" />

  <pin-filter-panel
    :initial-filter="initialFilter"
    :zone-data="zoneData"
    :bts-data="BTSData"
    :mrt-data="MRTData"
    :airport-data="AirportLinkData"
    :tags-data="tagsOptions"
    @apply-filter="applyFilter"
    @clear-filter="clearFilter"
  />

<b-card no-body>
  <div class="m-2">
    <b-row>
      <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
        <label>Entries</label>
        <v-select
          v-model="perPage"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="perPageOptions"
          :clearable="false"
          class="per-page-selector d-inline-block ml-50 mr-1"
        />
      </b-col>
    </b-row>
  </div>

  <b-table
    ref="refPropertipyListTable"
    :items="fetchPropertypins"
    responsive
    striped
    :fields="tableColumns"
    primary-key="id"
    :sort-by.sync="sortBy"
    show-empty
    empty-text="No matching records found"
    :sort-desc.sync="isSortDirDesc"
    class="position-relative"
  >
    <template #cell(image)="data">
      <div class="mb-1">
        <b-link variant="flat-primary" class="pb0" :to="{ name: 'pin-upload', params: { id: data.item.id } }">   
        <b-img class="img_property" v-if="data.item.place_image "
          :src="data.item.place_image"
          fluid
        />

        <b-img  class="img_property" v-else
          :src="'https://digitalnation.sgp1.cdn.digitaloceanspaces.com/findbangkokroom/storage/1698858264911-picture.png'"
          fluid
        />
      </b-link>
      </div>
      <b-link  variant="flat-primary" class="pb0" :to="{ name: 'pin-floorplan', params: { id: data.item.id } }">Floor Plan</b-link>
      <b-button  v-ripple.400="'rgba(255, 255, 255, 0.15)'" class="ml-1" size="sm" variant="success" @click="popopNearBy(data.item)">Near By</b-button>
    </template>

    <template #cell(name)="data">
      <router-link :to="{ name: 'pin-edit', params: { id: data.item.id } }" >{{ data.item.name[currentLocale] }}</router-link>
    </template>

    <template #cell(rate)="data">
      {{ data.item.rating }}
    </template>

    <template #cell(is_active)="data">
      <b-form-checkbox
        v-if="data.item.is_active == 1"
        checked="true"
        class="custom-control-primary"
        name="is_active"
        switch
      />

      <b-form-checkbox
        v-else
        checked="false"
        class="custom-control-primary"
        name="is_active"
        switch
      />
    </template>

    <template #cell(actions)="data">
      <span>
        <b-dropdown
          variant="link"
          toggle-class="text-decoration-none"
          no-caret
        >
          <template v-slot:button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="text-body align-middle mr-25"
            />
          </template>

          <b-dropdown-item  :to="{ name: 'pin-edit', params: { id: data.item.id } }" > 
            <feather-icon
              icon="Edit2Icon"
              class="mr-50"
            />
            <span>Edit</span>
          </b-dropdown-item>
          <b-dropdown-item @click="deleteconfirm(data.item.id)">
            <feather-icon
              icon="TrashIcon"
              class="mr-50"
            />
            <span>Delete</span>
          </b-dropdown-item>
        </b-dropdown>
      </span>  
    </template>   
  </b-table>

  <div class="mx-2 mb-2">
    <b-row>
      <b-col
        cols="12"
        sm="6"
        class="d-flex align-items-center justify-content-center justify-content-sm-start"
      >
        <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
      </b-col>

      <!-- Pagination -->
      <b-col
        cols="12"
        sm="6"
        class="d-flex align-items-center justify-content-center justify-content-sm-end"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="totalPins"
          :per-page="perPage"
          first-number
          last-number
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </b-col>
    </b-row>
  </div>    
</b-card>
</div> 
</template>

<script>
import {
  BCard, BRow, BCol, BFormCheckbox, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, BImg
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import vSelect from 'vue-select'
import { onUnmounted, onMounted, computed } from '@vue/composition-api'
import store from '@/store'
import usePropertypinList from './usePropertypinList'
import propertypinStoreModule from '../propertypinsStoreModule'
import nearByList from './nearByList.vue'
import PinFilterPanel from './PinFilterPanel.vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormCheckbox,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BImg,
    vSelect,
    nearByList,
    PinFilterPanel
  },
  setup() {
    const PROPERTYPIN_APP_STORE_MODULE_NAME = 'app-propertypin'
    if (!store.hasModule(PROPERTYPIN_APP_STORE_MODULE_NAME)) store.registerModule(PROPERTYPIN_APP_STORE_MODULE_NAME, propertypinStoreModule)

    const imgPath = store.state.appConfig.layout.imgPath

    onUnmounted(() => {
      if (store.hasModule(PROPERTYPIN_APP_STORE_MODULE_NAME)) store.unregisterModule(PROPERTYPIN_APP_STORE_MODULE_NAME)
    })

    const statusOptions = [
      'Unknow',
      'Sale & Rent',
      'Sale',
      'Rent',
    ]

    onMounted(() => {
      fetchBts()
      fetchMrt()
      fetchAirportLink()
      fetchZone()
      fetchTags()
    })

    const {
      fetchPropertypins,
      fetchBts,
      tableColumns,
      perPage,
      currentPage,
      totalPins,
      dataMeta,
      perPageOptions,
      sortBy,
      isSortDirDesc,
      refPropertipyListTable,
      statusPin,
      filterId,
      filterName,
      filterRate,
      deleteData,
      refetchData,
      BTSData,
      fetchMrt,
      MRTData,
      AirportLinkData,
      fetchAirportLink,
      fetchZone,
      zoneData,
      TagsData,
      fetchTags,
      selectedZoneId,
      selectedBTSId,
      selectedMRTId,
      selectedAirportlinkId,
      selectedTagsId,
      isNearBySidebarActive,
      popopNearBy,
      placeData,
      applyFilter,
      clearFilter
    } = usePropertypinList()

    const initialFilter = computed(() => ({
      byID: filterId.value,
      keyword: filterName.value,
      byRating: filterRate.value,
      byZone: selectedZoneId.value,
      byBTS: selectedBTSId.value,
      byMRT: selectedMRTId.value,
      byAirportlink: selectedAirportlinkId.value,
      byTags: selectedTagsId.value,
    }))

    return {
      fetchPropertypins,
      fetchBts,
      tableColumns,
      perPage,
      currentPage,
      totalPins,
      dataMeta,
      perPageOptions,
      sortBy,
      isSortDirDesc,
      refPropertipyListTable,
      statusPin,
      imgPath,
      statusOptions,
      deleteData,
      refetchData,
      BTSData,
      fetchMrt,
      MRTData,
      AirportLinkData,
      fetchAirportLink,
      fetchZone,
      zoneData,
      TagsData,
      fetchTags,
      isNearBySidebarActive,
      popopNearBy,
      placeData,
      applyFilter,
      clearFilter,
      initialFilter
    }
  },
  directives: {
    Ripple,
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale
    },
    tagsOptions() {
      return this.TagsData.map(t => ({ id: t.id, name: t.name[this.currentLocale] }))
    },
  },
   methods:{
    deleteconfirm(id){
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete Property ID.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if(value === true){
            this.deleteData(id)
          }
        })
      
    }
  },
  
    //
  
}
</script>
